<script setup lang="ts">
    import { reactive, ref, defineEmits } from 'vue';
    import axios from 'axios';

    const emit = defineEmits(['authenticated']);

    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        username: '', 
        password: '',
    });
    const formErrors = reactive({
        username: '',
        password: '',
    });

    function validate() {
        let isValid = true;

        formErrors.username = '';
        if (!formData.username) {
            formErrors.username ="Le nom d'utilisateur est requis";
            isValid = false;
        }

        formErrors.password = '';
        if (!formData.password) {
            formErrors.password ="Le nom d'utilisateur est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const httpResponse = await axios.post(`/backoffice/auth/signin`, formData);
            emit("authenticated", httpResponse.data);

            /*if (tokenHttpResponse.data.password_expired) {
                openRenewPasswordModal();
            } else if (tokenHttpResponse.data.mfa_enabled) {
                mfaAuthenticationModalRef.value?.open(accessToken.value);
            } else {
                await saveAuthSession(accessToken.value);
                await router.replace('/app/admins/list');
            }*/
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }
</script>

<template>
    <div>
        <h1 class="font-semibold my-8 text-center">Connexion <span class="text-sm text-grey-500"></span></h1>
        <form class="form" @submit.prevent="onSubmit">
            <div class="form-field-floating lg reactive my-5">
                <input type="text" class="form-input" v-model="formData.username" name="identifiant" id="identifiant" placeholder="" :readonly="loading" autofocus>
                <label for="identifiant">Identifiant <b class="color-danger">*</b></label>
            </div>
            <div class="form-field-floating lg reactive my-5">
                <input type="password" class="form-input" v-model="formData.password" name="password" id="password" placeholder="" :readonly="loading">
                <label for="password">Mot de passe <b class="color-danger">*</b></label>
            </div>
            <div class="mt-7">
                <div v-if="!!errorMessage" class="text-red text-center mb-5">{{ errorMessage }}</div>
                <div class="flex ">
                    <div class="s14">
                        <custom-button type="submit" :classesList="'btn xl w-100'" :loading="loading">
                            <img src="/icons/icon-menu-securite.svg" class="btn-icon" alt="" />
                            <span>Connexion</span>
                        </custom-button>
                    </div>
                    <div class="s6 flex-right">
                        <label class="form-switch">
                            <div class="switch">
                                <input type="checkbox" checked>
                                <span class="slider round"></span>
                            </div>
                            <h6 class="label text-grey-600">Rester connecté</h6>
                        </label>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
